import { Pipe, PipeTransform } from '@angular/core';
import {
  DomSanitizer,
  SafeHtml,
  SafeStyle,
  SafeScript,
  SafeUrl,
  SafeResourceUrl,
} from '@angular/platform-browser';
import * as moment from 'moment';
import { CommonService } from '../services/common.service';

/**
 * Sanitize HTML
 */
@Pipe({
  name: '$',
})
export class currencyFormatPipe implements PipeTransform {
  constructor(private commonService: CommonService) {}

  transform(value: any): any {
    if (!value) {
      return 0;
    }
    return this.commonService.ConverTienCoDauPhay2(value);
  }
}
